import { render, staticRenderFns } from "./DialogEditPassword.pug?vue&type=template&id=c570b2de&lang=pug&"
import script from "./DialogEditPassword.vue?vue&type=script&lang=js&"
export * from "./DialogEditPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports